import { useTranslation } from 'react-i18next';

interface OnboardingBannerProps {
  stepLabel: string;
  message: string;
  onSkip: () => void;
}

export function OnboardingBanner({ stepLabel, message, onSkip }: OnboardingBannerProps) {
  const { t } = useTranslation();
  return (
    <>
      <style>{`
        @keyframes onboarding-banner-in {
          from { opacity: 0; transform: translateY(-100%); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div
        className="fixed top-0 left-0 right-0 z-[55] bg-zinc-900/95 backdrop-blur-sm border-b border-violet-500/30"
        style={{ animation: 'onboarding-banner-in 300ms ease-out' }}
      >
        <div className="max-w-4xl mx-auto flex items-center justify-between py-2.5 px-4 sm:px-6">
          <div className="flex items-center gap-3">
            <span className="text-xs font-medium text-violet-400 bg-violet-500/10 px-2 py-0.5 rounded">
              {stepLabel}
            </span>
            <span className="text-sm text-zinc-300">{message}</span>
          </div>
          <button
            type="button"
            onClick={onSkip}
            className="text-xs text-zinc-500 hover:text-zinc-300 transition-colors"
          >
            {t('common.skip')}
          </button>
        </div>
      </div>
    </>
  );
}
